import en from "./en.json";
import es from "./es.json";
import signinTemplate from "./signin.html";
import LOGO_URL from "../../../../../assets/harvust-logo-008.svg";

class SigninController {
    /* @ngInject */
    constructor() {
        this.LOGO_URL = LOGO_URL;
    }
}

export default {
    controller: SigninController,
    template: signinTemplate,
    bindings: { credentials: "<" },
    name: "signin",
    translations: { en, es },
};
